ski = window.ski || {};

ski.form = {
	removeInvoice: function(el) {
		var $this = $(el),
			idx = $this.attr('data-index');

		$.ajax({
			'type': 'post',
			'url': '/_/moya/ski/ajax/removeinvoice',
			'data': {
				'index': idx
			}
		}).done(function(r) {
			if (r) {
				$this.parents('tr').remove();
			}
		});

		return false;
	},

	validate: function(form) {
		var $form = $(form),
			r = true;

		$form.find('#day_1,#day_2,#day_3,#day_4,#day_5').each(function() {
			var $datepicker = $(this);
			if ($datepicker.val()) {
				var $timeslot = $form.find('#timeslot_'+$datepicker.attr('id').replace('day_', ''));
				if ($timeslot.length && $timeslot.val() < 1) {
					$timeslot.append('<div id="timeslot_error">Þú verður að velja tíma fyrir daginn.</div>');
					$( "#timeslot_error" ).dialog({
						modal: true,
						buttons: {
							Ok: function() {
								$( this ).dialog( "close" );
							}
						}
					});

					r = false;
					return r;
				}
			}
		});

		return r;
	},

	participantDP: function () {
		ski.days.getAvailable(function() {
			$('#day_1,#day_2,#day_3,#day_4,#day_5').datepicker({
				dateFormat: 'dd.mm.yy',
				constrainInput: true,
				beforeShowDay: ski.days.isAvailable,
				onSelect: function(date) {
					var $dp = $(this);
					ski.timeslot.getAvailable(date, function() {
						var id = $dp.attr('id').replace('day_', ''),
							$timeslot = $('#timeslot_'+id);

						$timeslot.html('').append($("<option />").val('-1').text('--'));

						$.each(ski.timeslot.available, function() {
							$timeslot.append($("<option />").val(this.id).text(this.title));
						});
					});
				}
			});

			$('#day_1,#day_2,#day_3,#day_4,#day_5').each(function () {
				var $this = $(this);

				if ($this.val().length) {
					ski.timeslot.getAvailable($this.val(), function() {
						var id = $this.attr('id').replace('day_', ''),
							$timeslot = $('#timeslot_'+id);

						// Don't populate a select that has something selected
						if (!$timeslot.val()) {
							$timeslot.html('').append($("<option />").val('-1').text('--'));

							$.each(ski.timeslot.available, function() {
								$timeslot.append($("<option />").val(this.id).text(this.title));
							});
						}
					});
				}
			});
		});
	},

	toggleResponsible: function () {
		$('#responsible').bind('click', function() {
			var checkbox = $(this);
			if (checkbox.is(':checked')) {
				$('#fieldset-respo').show();
			}
			else {
				$('#fieldset-respo').hide();
			}
		});

		if ($('#responsibleName').val()) {
			$('#fieldset-respo').show();
			$('#responsible').attr('checked', true);
		}
	}
};

ski.days = {
	getAvailable: function (callback) {
		$.ajax({
			'type': 'get',
			'url': '/_/moya/ski/ajax/requestavailabledays'
		}).done(function(r) {
			ski.days.available = r.split(',');
			callback();
		});
	},
	isAvailable: function (date) {
		if (ski.days.available == '*') {
			return [true];
		}

		var m = date.getMonth(), d = date.getDate(), y = date.getFullYear();
		for (i = 0; i < ski.days.available.length; i++) {
			var day = d + '-' + (m+1) + '-' + y;
			if ($.inArray(day, ski.days.available) !== -1) {
				return [true];
			}
		}

		return [false];
	}
};

ski.timeslot = {
	getAvailable: function (date, callback) {
		$.ajax({
			'type': 'get',
			'url': '/_/moya/ski/ajax/requesttimeslots',
			'data': {
				date: date
			}
		}).done(function(r) {
			ski.timeslot.available = r;
			callback();
		});
	}
};

ski.fullcalendar = {
	init: function (element, options) {
		$(element).fullCalendar({
			monthNames: options.monthNames,
			monthNamesShort: options.monthNamesShort,
			dayNames: options.dayNames,
			dayNamesShort: options.dayNamesShort,
			buttonText: options.buttonText,
			timeFormat: options.timeFormat,
			events: {
				url: options.source,
				cache: true
			},
			eventClick: function (calEvent, jsEvent, view) {
				if (calEvent.url) {
					var url = '/_'+calEvent.url.replace('/is', '');
					$('.calendarEventDialog')
						.load(url, null, function() {
							$('.calendarEventDialog').find('#cancel')
								.bind('click', function(e) {
									e.preventDefault();
									$('.calendarEventDialog').dialog("close");
								});
						})
						.dialog({
							width:'50%',
							title:calEvent.title,
							resize: 'auto',
							draggable: false
						});

					return false;
				}
			}
		});
	}
};


$(function() {
	$('#tsFrom').datepicker({
		dateFormat: 'dd.mm.yy',
		onClose: function( selectedDate ) {
			$( "#tsTo" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$('#tsTo').datepicker({
		dateFormat: 'dd.mm.yy'
	});
});
